import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OBJ } from 'constants';
import IconButtonWithTooltip from './IconButtonWithTooltip';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

const OpenDetailsButton = ({ id, tooltipId, icon, obj}) => {
    const navigate = useNavigate();

    const openUpload = () => navigate(`/admin/${obj === OBJ.COMPANIES ? OBJ.CUSTOMERS : obj}/${id}`, { replace: false });
    return (
        <IconButtonWithTooltip
            translationId={tooltipId || 'button.openDetails'}
            icon={icon || faArrowUpRightFromSquare}
            onClick={openUpload}
            type="Button"
        />
    );
};

export default OpenDetailsButton;
